module.exports = __webpack_public_path__ + "static/fighter-AYAGWW-3e2d8eab8487c4e953ab875dcf920fe1.png";